import { useEffect, useRef, useState } from "react";
import loader from "../../../assets/images/loader.gif";
import noimg from "../../../assets/images/noimg.webp";
import Pagination from "../../../components/common/Pagination";
import ListAction from "../../../components/dashboard/admin-dashboard/ListAction";
import ProductDetailModal from "../../../components/dashboard/admin-dashboard/detail-modal/ProductDetailModal";
import TopHeader from "../../../components/dashboard/user-dashboard/TopHeader";
import { deletePrduct } from "../../../service/DashboardService";
import { getProductById } from "../../../service/MainService";
import { getAllProducts } from "../../../service/DashboardService";
import DoubleConfirm from "../../../components/dashboard/common/DoubleConfirm";

const AllProductList = () => {
  const [products, setProducts] = useState([]);
  const [productDetail, setProductDetail] = useState();
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalProductCount, setTotalProductCount] = useState(0);
  const topRef = useRef(null);
  const [deletingProductId, setDeletingProductId] = useState(null);
  const [doubleAlert, setDoubleAlert] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await getAllProducts(currentPage, 10);
        setProducts(response.Result);
        setTotalProductCount(response.TotalProducts);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching projects:", error);
        setLoading(false);
      }
    };
    fetchData();
    scrollToTop();
  }, [currentPage]);

  const handleViewClick = async (productId) => {
    try {
      const token = localStorage.getItem("accessToken");
      const response = await getProductById(productId, token);
      setProductDetail(response);
      setOpen(true);
    } catch (error) {
      console.error("Error fetching user details:", error);
    }
  };

  const handleDeleteProduct = async (productId) => {
    setDeletingProductId(productId);
    setDoubleAlert(true);
  };

  const confirmDeleteProduct = async () => {
    try {
      await deletePrduct(deletingProductId);
      setProducts((prevProducts) =>
        prevProducts.filter(
          (product) => product.ProductId !== deletingProductId
        )
      );
      setDeletingProductId(null);
      setDoubleAlert(false);
    } catch (error) {
      console.error("Error deleting product:", error);
    }
  };

  const handlePageChange = (page, e) => {
    e.preventDefault();
    setCurrentPage(page);
  };

  const scrollToTop = () => {
    if (topRef.current) {
      topRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  const renderTableRows = () => {
    return products?.map((pro, i) => (
      <tr
        key={i}
        className="bg-white border-b text-center dark:bg-gray-800 dark:border-gray-700"
      >
        <td className="px-6 py-4">{pro.ProductName || "NA"}</td>
        <td className="px-6 py-4">
          <img
            src={pro.Image1Main || noimg}
            alt={pro.ProductName || "Product Preview"}
            className="mx-auto w-20 shadow-md object-cover"
            style={{width:'80px', height:'80px'}}
          />
        </td>
        <td className="px-6 py-4">{pro.PrdtCategory || "NA"}</td>
        <td className="px-6 py-4">{pro?.user?.UserName || "NA"}</td>
        <td className="px-6 py-4">
          <ListAction
            onViewClick={() => handleViewClick(pro.ProductId)}
            onDeleteClick={() => handleDeleteProduct(pro.ProductId)}
            showDeleteButton={true}
          />
        </td>
      </tr>
    ));
  };

  return (
    <>
      <div ref={topRef} />
      <TopHeader />
      {/* <SearchBar /> */}
      {loading ? (
        <div className="flex justify-center ">
          <img src={loader} alt="Loading" />
        </div>
      ) : (
        <div className="">
          <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
            <thead className="text-xs text-gray-700 uppercase text-center bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
              <tr>
                <th scope="col" className="px-6 py-3">
                  Product Name
                </th>
                <th scope="col" className="px-6 py-3">
                  Main Image(Preview)
                </th>
                <th scope="col" className="px-6 py-3">
                  Product Category
                </th>
                <th scope="col" className="px-6 py-3">
                  Owner
                </th>

                <th scope="col" className="px-6 py-3"></th>
              </tr>
            </thead>
            <tbody>
              {products.length === 0 ? (
                <tr>
                  <td colSpan="4" className="text-center py-4">
                    No records found
                  </td>
                </tr>
              ) : (
                renderTableRows()
              )}
            </tbody>
          </table>
          {totalProductCount > 10 && (
            <Pagination
              currentPage={currentPage}
              totalItems={totalProductCount}
              onPageChange={handlePageChange}
            />
          )}
        </div>
      )}
      {productDetail && (
        <ProductDetailModal
          open={open}
          setOpen={setOpen}
          productDetail={productDetail}
        />
      )}
      <DoubleConfirm
        open={doubleAlert}
        setOpen={setDoubleAlert}
        onConfirm={confirmDeleteProduct}
      />
    </>
  );
};

export default AllProductList;
